import { mainDialogState } from '@/plugins/mainDialogService'

function normalizeContent(h, content) {
  if (Array.isArray(content)) {
    return content
  }

  if (content && typeof content === 'object' && content.tag) {
    return [content]
  }

  return [h('p', { class: ['mb-0'] }, String(content || ''))]
}

export default {
  name: 'MainDialogHost',

  computed: {
    state() {
      return mainDialogState
    },

    isConfirm() {
      return this.state.mode === 'confirm'
    },
  },

  methods: {
    ok() {
      this.$mainDialog.ok()
    },

    cancel() {
      this.$mainDialog.cancel()
    },
  },

  render(h) {
    const options = this.state.options || {}
    const title = Array.isArray(this.state.title) || (this.state.title && typeof this.state.title === 'object')
      ? ''
      : this.state.title

    const children = normalizeContent(h, this.state.message)

    return h('main-dialog', {
      props: {
        id: options.id || null,
        value: this.state.show,
        title,
        size: options.size || 'md',
        hideHeader: !!options.hideHeader,
        hideFooter: !!options.hideFooter,
        okTitle: options.okTitle || (this.isConfirm ? 'OK' : 'OK'),
        cancelTitle: options.cancelTitle || 'Cancel',
        okVariant: options.okVariant || 'primary',
        cancelVariant: options.cancelVariant || 'secondary',
        okOnly: !this.isConfirm,
      },
      on: {
        ok: this.ok,
        cancel: this.cancel,
        close: this.cancel,
      },
      scopedSlots: Array.isArray(this.state.title) || (this.state.title && typeof this.state.title === 'object')
        ? {
          'modal-header': ({ close }) => h('div', { class: ['d-flex', 'align-items-center', 'justify-content-between', 'w-100'] }, [
            h('div', normalizeContent(h, this.state.title)),
            h('button', { class: ['mp-dialog-close'], on: { click: close } }, [h('i', { class: ['bi', 'bi-x'] })]),
          ])
        }
        : {},
    }, children)
  },
}
